import { render } from "./Home.vue?vue&type=template&id=a7ae8a76&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=a7ae8a76&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a7ae8a76"

export default script
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage});
